import request from '@/utils/request';

export function getSysSetting(query) {
  return request({
    url: '/api/system/sysSetting/getSysSetting',
    method: 'post',
    data: query
  });
}

export function getSysCustomList(query) {
  return request({
    url: '/api/system/sysCustom/querySysCustomList',
    method: 'post',
    data: query
  });
}

export function getSysExpressCodingList(query) {
  return request({
    url: '/api/system/sysExpressCoding/querySysExpressCodingList',
    method: 'post',
    data: query
  });
}



// WEBPACK FOOTER //
// ./src/api/system/index.js